import React, { useState, useEffect } from "react";
import "./css/moderntheme.css"
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { InputGroup, Input, Row, Col, Card, CardText, CardTitle } from "reactstrap";
import { Button, CardActionArea, CardContent, CardActions, Typography, Badge } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { decode } from "html-entities";
import axios from "axios";

export default function Jobs() {
  axios.defaults.headers.common["Authorization"] = `Bearer ${global.config.Token}`;
  const [jobs, setJobs] = useState();
  const [batch, setBatch] = useState(true);
  const [loading, setLoading] = useState(true);
  const getData = async () => {

    const jobres = await axios.get(global.config.URL.api.lms + 'job-finder');
    console.log(jobres.data.jobs)
    setLoading(false)
    setBatch(jobres.data.batch)
    setJobs(jobres.data.jobs);
  }

  useEffect(() => {
    getData();
  }, []);
  const applied = (id) =>{
    axios.post(global.config.URL.api.lms + 'applied',{job_id:id});
  }
  return (<>
    <React.Fragment>
      <div className="page-content">
        <Breadcrumbs
          title="Dashboard"
          breadcrumbItem="Best Matched Jobs (BETA)"
        />
        {
          loading ?
            <Row>
              <Col md={12} sm={12} className="mt-3">
                <Stack spacing={1}>
                  <Skeleton variant="rectangular" width={'100%'} height={100} />
                  <Skeleton width="60%" />
                  <Skeleton width="10%" />
                  <Skeleton width="100%" height={50} />
                </Stack>
              </Col>
            </Row>

            :

            <Row>
              {
                jobs?.length  > 0  && batch ?
                  <>
                    {
                      jobs.map((job) => {
                        return (
                          <Col md={12} className="mb-3">
                            <Card body>
                              <CardTitle className="mt-0">
                                <h6 className="float-end m-0"><Badge className="bg-primary text-warning p-1 rounded">
                                 Apply Before: {job.deadline}
                                </Badge></h6>
                              </CardTitle>
                              <CardActionArea>
                                <CardContent>
                                  <Typography gutterBottom variant="h6" className='heading' component="div">
                                    {job.title}
                                  </Typography>
                                  <div style={{height:"200px",overflow:"auto"}}>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: job.descriptions
                                          ? decode(job.descriptions)
                                          : ""
                                      }}
                                    />
                                  </div>
                                </CardContent>
                              </CardActionArea>
                              <a href={job.link} onClick={() => applied(job.id)} target="_blank" className='btn btn-warning float-end'>
                                Apply For this job
                              </a>
                            </Card>
                          </Col>
                        )
                      })
                    }
                  </>
                  :
                  !batch ?
                    <Col md={12}>
                      <Card body>

                        <CardText>
                          <h2>Dear PFTPians,</h2>
                          We’re excited about your journey with us! After your results are announced, we will assist you in finding the best job match to start your career.
                          Stay focused on your course, and let’s work together to achieve your goals! 🚀
                        </CardText>

                      </Card>
                    </Col>
                    :
                    <Col md={12}>
                      <Card body>

                        <CardText>
                          <h2>No Job Available</h2>
                          Currently, there are no job opportunities available. Please stay connected with us, as we are continually updating our listings.
                          We encourage you to continue building your skills and checking back regularly for new opportunities that align with your goals. Your success is our priority!

                        </CardText>

                      </Card>
                    </Col>
              }
            </Row>
        }


      </div>
    </React.Fragment>
  </>)
}